export default __webpack_public_path__ + "static/Matelas-aa0d48bf512a7c22e282a3ef1b225740.jpg";